package it.neckar.lizergy.model.location

import com.meistercharts.maps.Example
import com.meistercharts.maps.MapCoordinates
import it.neckar.lizergy.model.customer.AddressExample
import it.neckar.lizergy.model.energy.SpecificAnnualProduction
import kotlinx.serialization.Serializable

/**
 * Information about the location
 */
@Serializable
data class LocationInformation(
  /**
   * The address
   */
  val address: it.neckar.lizergy.model.customer.Address,
  /**
   * The coordinates (should correspond to the address)
   */
  val coordinates: MapCoordinatesInformation?,

  /**
   * The specific annual production at the given location
   */
  val specificAnnualProduction: SpecificAnnualProduction,
) {

  companion object {
    val empty: LocationInformation = LocationInformation(
      address = it.neckar.lizergy.model.customer.Address.empty,
      coordinates = null,
      specificAnnualProduction = SpecificAnnualProduction.LizergyDefault
    )

    val demo: LocationInformation = LocationInformation(
      address = AddressExample.muster,
      coordinates = null,
      specificAnnualProduction = SpecificAnnualProduction.LizergyDefault,
    )

    /**
     * The location of Neckar IT
     */
    val neckarIT: LocationInformation = LocationInformation(
      address = AddressExample.neckarIT,
      coordinates = MapCoordinates.Example.neckarIt.exact(),
      specificAnnualProduction = SpecificAnnualProduction.Moessingen,
    )
  }
}
